import React from "react";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { OWNER_PHONE, OWNER_EMAIL, LOCATION } from "@/api";

export const TopBar = () => (
  <div className="bg-[#0B0B0C] border-b border-white/10 text-xs text-zinc-400 hidden md:block">
    <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between items-center">
      <div className="flex items-center gap-6">
        <a href={`tel:${OWNER_PHONE.replace(/\s/g, "")}`} className="flex items-center gap-1.5 hover:text-[#E1BC56] transition" data-testid="topbar-phone">
          <Phone className="w-3.5 h-3.5" /> {OWNER_PHONE}
        </a>
        <a href={`mailto:${OWNER_EMAIL}`} className="flex items-center gap-1.5 hover:text-[#E1BC56] transition" data-testid="topbar-email">
          <Mail className="w-3.5 h-3.5" /> {OWNER_EMAIL}
        </a>
        <span className="flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5" /> {LOCATION}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:text-[#E1BC56] transition" data-testid="topbar-instagram"><Instagram className="w-4 h-4" /></a>
        <a href="https://facebook.com" target="_blank" rel="noreferrer" className="hover:text-[#E1BC56] transition" data-testid="topbar-facebook"><Facebook className="w-4 h-4" /></a>
        <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="hover:text-[#E1BC56] transition font-bold text-xs" data-testid="topbar-tiktok">TikTok</a>
      </div>
    </div>
  </div>
);
